import React from "react";

interface ImportPreviewTableProps {
  headers: string[];
  previewData: Record<string, unknown>[];
  allowedHeaders: string[];
}

export const ImportPreviewTable: React.FC<ImportPreviewTableProps> = ({
  headers,
  previewData,
  allowedHeaders,
}) => {
  if (previewData.length === 0) return null;

  return (
    <div className="space-y-4 pt-6 border-t border-slate-100">
      <h3 className="text-[18px] font-bold text-slate-800">Preview (First 5 Rows)</h3>
      <div className="border border-slate-100 rounded-[12px] overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse text-[13px]">
            <thead className="bg-slate-50/75 border-b border-slate-100">
              <tr>
                {headers.map((header) => (
                  <th key={header} className="px-4 py-3.5 font-bold text-slate-700 capitalize">
                    {header}
                    {!allowedHeaders.includes(header) && (
                      <span className="text-[#EF4444] ml-1" title="Unsupported column">*</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 bg-white">
              {previewData.map((row, index) => (
                <tr key={index} className="hover:bg-slate-50/30 transition-colors">
                  {headers.map((header) => (
                    <td key={header} className="px-4 py-3 text-slate-600 font-medium truncate max-w-[200px]">
                      {String(row[header] ?? '—')}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
